<template>
  <div class="page-container flex items-center justify-center min-h-[60vh] animate-fade-in">
    <BaseEmpty icon="file" title="Page not found" description="The page you're looking for doesn't exist or has been moved.">
      <template #action>
        <BaseButton variant="primary" tag="router-link" to="/">
          <AppIcon name="Home" :size="16" />
          Back to Home
        </BaseButton>
      </template>
    </BaseEmpty>
  </div>
</template>

<script>
import BaseEmpty from '@/components/ui/BaseEmpty.vue'
import BaseButton from '@/components/ui/BaseButton.vue'
import AppIcon from '@/components/ui/AppIcon.vue'

export default {
  name: 'NotFoundPage',
  components: { BaseEmpty, BaseButton, AppIcon },
}
</script>
